"use client"

const ProductCard = ({ product, onClick }) => {
  return (
    <div className="product-card" onClick={onClick}>
      <div className="product-image-container">
        <img
          src={process.env.PUBLIC_URL + product.imageUrl || "/placeholder.svg"}
          alt={product.name}
          className="product-image"
          onError={(e) => {
            e.target.onerror = null
            e.target.src = "/placeholder.svg?height=200&width=200"
          }}
          loading="lazy"
        />
      </div>
      <div className="product-card-info">
        <h3>{product.name}</h3>
        <div className="product-price">${product.price}</div>
        <div className="product-stock">
          <span
            className={`stock-indicator ${
              product.availability > 10 ? "in-stock" : product.availability > 0 ? "low-stock" : "out-of-stock"
            }`}
          ></span>
          {product.availability > 0
            ? product.availability > 10
              ? `In Stock (${product.availability})`
              : `Low Stock (${product.availability})`
            : "Out of Stock"}
        </div>
      </div>
    </div>
  )
}

export default ProductCard
